// YAML syntax highlighter, returns HTML string
export function hlYAML(raw: string): string {
  if (!raw) return "";
  const esc = (s: string) =>
    s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

  return raw
    .split("\n")
    .map((line) => {
      if (!line.trim()) return "";
      if (line.trim().startsWith("#"))
        return `<span class="hl-cmt">${esc(line)}</span>`;

      let s = esc(line);
      // key:
      s = s.replace(
        /^(\s*)([a-zA-Z_][\w-]*)(:\s*)/m,
        (_, indent, key, colon) =>
          `${indent}<span class="hl-key">${key}</span><span class="hl-punc">${colon}</span>`
      );
      // list item dash
      s = s.replace(
        /^(\s*)(- )/m,
        (_, indent, dash) => `${indent}<span class="hl-dash">${dash}</span>`
      );
      // single-quoted strings
      s = s.replace(/('[^'\n]*')/g, (m) => `<span class="hl-str">${m}</span>`);
      // double-quoted strings
      s = s.replace(/(&quot;[^&\n]*&quot;)/g, (m) => `<span class="hl-str">${m}</span>`);
      // numbers
      s = s.replace(
        /(:\s*)(\d+(?:\.\d+)?)\s*$/m,
        (_, c, n) => `${c}<span class="hl-num">${n}</span>`
      );
      // booleans / keywords
      s = s.replace(
        /(:\s*)(true|false|yes|no|null|experimental|stable|test|deprecated)\s*$/m,
        (_, c, b) => `${c}<span class="hl-bool">${b}</span>`
      );
      return s;
    })
    .join("\n");
}
